import { checkAccess } from '@vincesoftware/vincelive-authorizer';
import { Action } from 'vince-core/types/roles';
import { VinceApp } from 'vince-core/composables/usePermission';
import { useUserStore } from 'vince-core/stores/userStore';
import { ResourceType } from 'vince-core/types/common';


export const usePermission = () => {
    const userStore = useUserStore();
    function hasPermission (res: {resource?: ResourceType, resourceId?: string, action?: Action}) {
        try {
            checkAccess({
                // @ts-ignore
                auth: {
                    ...userStore.userInfo,
                    ...userStore.userPermission
                },
                truthPermissions: {
                    app: VinceApp.AI_APPS,
                    resource: res.resource ? res.resource : ResourceType.APP.toString(),
                    resourceId: res.resourceId ? res.resourceId : '*',
                    action: res.action ? res.action : '*'
                }
            });
            return true;
        } catch (e) {
            return false;
        }
    }

    return {
        hasPermission
    };
};
